import {DataTableValueArray} from "primereact/datatable";

export interface Page<T> {
    content?: DataTableValueArray
    last?: boolean
    totalPages?: number
    totalElements?: number
    first?: boolean
    size: number;
    number: number;
    numberOfElements?: number
    empty?: boolean
}

export function getDefaultPage<T>(initialSize?: number): Page<T> {
    return {
        content: [],
        last: false,
        totalPages: 0,
        totalElements: 0,
        first: true,
        size: initialSize?? 10,
        number: 0,
        numberOfElements: 0,
        empty: true,
    };
}
